<template>
  <AdminLayout v-model:activeTab="view">
    <!-- Mantenimiento -->
    <div v-if="view === 'eventos'"><CrudEventos /></div>
    <div v-if="view === 'moldes'"><CrudMoldes /></div>
    <div v-if="view === 'tipos'"><CrudTiposEvento /></div>

    <!-- Inventario (agrega los componentes cuando los tengas) -->
    <!-- <div v-if="view === 'unidades'">   <CrudUnidades />   </div> -->
    <!-- <div v-if="view === 'articulos'">  <CrudArticulos />  </div> -->

    <!-- Pedidos -->
    <!-- <div v-if="view === 'clientes'">   <CrudClientes />   </div> -->
    <!-- <div v-if="view === 'pedidos'">    <CrudPedidos />    </div> -->
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import CrudEventos from "@/components/Mantenimientos/CrudEventos.vue";
import CrudMoldes from "@/components/Mantenimientos/CrudMoldes.vue";
import CrudTiposEvento from "@/components/Mantenimientos/CrudTiposEvento.vue";

const view = ref("eventos");
</script>
